import { render, staticRenderFns } from "./objTextSelected.vue?vue&type=template&id=46890f50&"
import script from "./objTextSelected.vue?vue&type=script&lang=ts&"
export * from "./objTextSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports